import React, { useState, useRef } from 'react';
import StepProgressBar from '../common/stepBar';
import { useNavigate } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
import { useTranslation } from 'react-i18next';
import { LOGIN, SIGNUP , VERIFYOTP } from '../helpers/Constant';
import { postData } from '../api/api';

function Register() {
  const navigate = useNavigate();
  const pendingStep = 1;
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  
  const fnameRef = useRef(null);
  const lnameRef = useRef(null);
  const emailRef = useRef(null);
  const passwordRef = useRef(null);

  const handleChange = (event, field) => {
    const value = event.target.value;
    const newErrors = { ...formErrors };

    switch (field) {
      case 'fname':
        if (!value.trim()) {
          newErrors.fname = t('First name is required.');
        } else if (value.trim().length < 2) {
          newErrors.fname = t('First name must be at least 2 characters.');
        } else {
          delete newErrors.fname;
        }
        break;
      case 'lname':
        if (!value.trim()) {
          newErrors.lname = t('Last name is required.');
        } else if (value.trim().length < 2) {
          newErrors.lname = t('Last name must be at least 2 characters.');
        } else {
          delete newErrors.lname;
        }
        break;
      case 'email':
        if (!value.trim()) {
          newErrors.email = t('Email is required.');
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          newErrors.email = t('Invalid email address.');
        } else {
          delete newErrors.email;
        }
        break;
      case 'password':
        if (!value.trim()) {
          newErrors.password = t('Password is required.');
        } else if (value.length < 6) {
          newErrors.password = t('Password must be at least 6 characters.');
        } else {
          delete newErrors.password;
        }
        break;
      default:
        break;
    }

    setFormErrors(newErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formValues = {
      fname: fnameRef.current.value,
      lname: lnameRef.current.value,
      email: emailRef.current.value,
      password: passwordRef.current.value,
    };

    const errors = {};
    if (!formValues.fname.trim()) {
      errors.fname = t('First name is required.');
    } else if (formValues.fname.trim().length < 2) {
      errors.fname = t('First name must be at least 2 characters.');
    }

    if (!formValues.lname.trim()) {
      errors.lname = t('Last name is required.');
    } else if (formValues.lname.trim().length < 2) {
      errors.lname = t('Last name must be at least 2 characters.');
    }

    if (!formValues.email.trim()) {
      errors.email = t('Email is required.');
    } else if (!/\S+@\S+\.\S+/.test(formValues.email)) {
      errors.email = t('Invalid email address.');
    }

    if (!formValues.password.trim()) {
      errors.password = t('Password is required.');
    } else if (formValues.password.length < 8) {
      errors.password = t('Password must be at least 8 characters.');
    }

    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      try {
        const response = await postData(SIGNUP, formValues);
        
        if (response.status === 200 || response.status === 201) {          
          navigate(`/${VERIFYOTP}`, { 
            state: { 
              userData: response.data,
              email: formValues.email,
              password: formValues.password
            } 
          });

        } else if (response.status === 422) {
          setFormErrors(prev => ({ ...prev, email: response.message }));
        }
      } catch (error) {
        console.error('Registration error:', error);
        setFormErrors(prev => ({ 
          ...prev, 
          email: error.response?.data?.message || 'An unexpected error occurred.' 
        }));
      }
    }
    
    setLoading(false);
  };

  return (
    <div className='wrapper bg_paper d-flex flex-column h-100'>
      {loading && (
        <div className="loader">
          <Oval color="#daff00" secondaryColor="#ffffff" strokeWidth={3} strokeWidthSecondary={3} height={50} width={50} />
        </div>
      )}

      <div className='d-flex justify-content-center'>
        <StepProgressBar pendingStep={pendingStep} />
      </div>

      <div className='log_in_wrapper flex-fill d-flex flex-column'>
        <div className='logo_wrapper flex-fill d-flex justify-content-center align-items-center py-3'>
          <img src='../images/muvelogo.png' alt="MUVE" />
        </div>
        
        <div className='login-inner'>
          <div className='auth_section otp_section bg-primary d-grid gap-3 p-3 rounded-4 w-100 mx-auto'>
            <h3 className='text-white fw-bold text-center'>{t('Sign Up')}</h3>
            <form className='sign_up_form' onSubmit={handleSubmit} autoComplete='off' noValidate >
              <div className='form_field position-relative mb-3'>
                <input  type="text" name="fname" id="fname"  ref={fnameRef} onChange={(e) => handleChange(e, 'fname')} className='w-100 px-3 border' placeholder={t('First name')} />
                <p className='field_error'>{formErrors.fname}</p>
              </div>
              <div className='form_field position-relative mb-3'>
                <input type="text" name="lname" id="lname" ref={lnameRef} onChange={(e) => handleChange(e, 'lname')} className='w-100 px-3 border' placeholder={t('Last name')} />
                <p className='field_error'>{formErrors.lname}</p>
              </div>
              <div className='form_field position-relative mb-3'>
                <input type="email" name="email" id="email" ref={emailRef} onChange={(e) => handleChange(e, 'email')} className='w-100 px-3 border' placeholder={t('Email')} />
                <p className='field_error'>{formErrors.email}</p>
              </div>
              <div className='form_field position-relative mb-3'>
                <input type="password" name="password" id="password" ref={passwordRef} onChange={(e) => handleChange(e, 'password')} className='w-100 px-3 border' placeholder={t('Password')}/>
                <p className='field_error'>{formErrors.password}</p>
              </div>

              <button type='submit' className='text-white w-100 guest_button rounded-3 my-3' disabled={loading}>
                {t('Sign Up')}
              </button>
            </form>
            <div className='resend-otp d-flex flex-wrap justify-content-center align-items-center'>
              <p className='text-white mb-0 me-2'>
                {t("already have an account?")}
              </p>
              <button className="text-warning bg-transparent border-0 p-0" onClick={() => navigate(`/${LOGIN}`)}>
                {t('Sign in')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;